// @flow
/* eslint-env browser */
import { get } from 'lodash';

type DocumentType = {
  documentElement: HTMLElement | null,
  body: HTMLElement | null,
};

function getTopScrollValue(document: DocumentType): number {
  return get(document, 'documentElement.scrollTop')
    ? get(document, 'documentElement.scrollTop')
    : get(document, 'body.scrollTop', 0);
}

let instances = 0;

function lockBodyScroll(document: DocumentType) {
  const body = get(document, 'body', {});

  if (body) {
    ++instances;
    // We add a "z-index: 0" on body to better handle portals on IE11
    body.setAttribute(
      'style',
      `overflow: hidden; position:fixed !important; top: -${getTopScrollValue(
        document,
      )}px;width: 100%;z-index:0;`,
    );
  }
}

function resumeBodyScroll(document: DocumentType, previousPosition: number) {
  const body = get(document, 'body', {});

  if (body && --instances === 0) {
    body.setAttribute('style', '');

    if (previousPosition !== 0) {
      body.scrollTop = previousPosition;
    }
  }
  if (document.documentElement) {
    if (previousPosition !== 0) {
      document.documentElement.scrollTop = previousPosition;
    }
  }
}

export { getTopScrollValue, lockBodyScroll, resumeBodyScroll };
